export default __webpack_public_path__ + "static/media/Finished fabric.4dab45c5.png";